import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import fetchLotInspections from '../api/fetchLotInspections';

/**
 * Inspection history for a lot, newest first. Also returns `invalidate`
 * so mutation callers can refetch without knowing the query key.
 */
export default function useLotInspections(lotId) {
  const queryClient = useQueryClient();

  const query = useQuery({
    queryKey: ['lotInspections', lotId],
    queryFn: () => fetchLotInspections(lotId),
    enabled: !!lotId,
  });

  const invalidate = useCallback(
    () => queryClient.invalidateQueries({ queryKey: ['lotInspections', lotId] }),
    [queryClient, lotId],
  );

  return { ...query, invalidate };
}
